import { useApp } from "../../state/store";
import { useT } from "../../i18n/store";
import { effectivePaper } from "../../domain/layout";
import { Section } from "../Section";
import { NumberInput } from "../NumberInput";
import { Checkbox } from "../Checkbox";

export const SignSizeSection = () => {
  const t = useT();
  const sign = useApp((s) => s.sign);
  const setSign = useApp((s) => s.setSign);
  const source = useApp((s) => s.source);

  const aspect = source ? source.widthPx / source.heightPx : 1;

  const onWidth = (width: number) => {
    if (sign.lockAspect && aspect > 0) {
      setSign({ width, height: width / aspect });
    } else {
      setSign({ width });
    }
  };
  const onHeight = (height: number) => {
    if (sign.lockAspect && aspect > 0) {
      setSign({ width: height * aspect, height });
    } else {
      setSign({ height });
    }
  };

  const onAutoFit = () => {
    if (!source) return;
    const { paper, margins, tile } = useApp.getState();
    const ep = effectivePaper(paper, margins, sign);
    const availW = ep.width  - margins.left - margins.right;
    const availH = ep.height - margins.top  - margins.bottom;
    const cols = tile.auto ? Math.max(1, Math.ceil(sign.width / availW))  : tile.cols;
    const rows = tile.auto ? Math.max(1, Math.ceil(sign.height / availH)) : tile.rows;
    const maxW = cols * availW;
    const maxH = rows * availH;
    const fitByW = { w: maxW, h: maxW / aspect };
    const fitByH = { w: maxH * aspect, h: maxH };
    const choice = fitByW.h <= maxH ? fitByW : fitByH;
    setSign({ width: choice.w, height: choice.h });
  };

  return (
    <Section title={t("section.signSize")}>
      <div className="row check">
        <Checkbox
          label={t("sign.lockAspect")}
          checked={sign.lockAspect}
          onChange={(lockAspect) => setSign({ lockAspect })}
        />
      </div>
      <div className="row two">
        <div>
          <label>{t("field.width")}</label>
          <NumberInput value={sign.width}  onChange={onWidth}  min={1} step={0.1} unit={t("unit.mm")} />
        </div>
        <div>
          <label>{t("field.height")}</label>
          <NumberInput value={sign.height} onChange={onHeight} min={1} step={0.1} unit={t("unit.mm")} />
        </div>
      </div>
      <div className="row btnrow">
        <button
          className="btn ghost full"
          title={t("sign.autoFit.title")}
          onClick={onAutoFit}
          disabled={!source}
        >
          {t("sign.autoFit")}
        </button>
      </div>
    </Section>
  );
};
